"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMotorWidgets = void 0;
var VehicleExistingDriverAdderWIdget_1 = require("./VehicleExistingDriverAdderWIdget");
var VehcleAddExistingDriverButtonWidget_1 = require("./VehcleAddExistingDriverButtonWidget");
var CarExcessWidget_1 = require("./CarExcessWidget");
var AddCarExcessWidget_1 = require("./AddCarExcessWidget");
var MainDriverPolarAnswerWidget_1 = require("./MainDriverPolarAnswerWidget");
var CarCancellationPriceOutputWidget_1 = require("./CarCancellationPriceOutputWidget");
var ViewAndEditCarDetailsWidget_1 = require("./ViewAndEditCarDetailsWidget");
var CarSpecificExcessWidget_1 = require("./CarSpecificExcessWidget");
var CarChangePriceOutputWidget_1 = require("./CarChangePriceOutputWidget");
var WhoIsRegisteredKeeperWidget_1 = require("./WhoIsRegisteredKeeperWidget");
var DriverKeeperPopupWidget_1 = require("./DriverKeeperPopupWidget");
var DisplayMultipleCarsDetailsWidget_1 = require("./DisplayMultipleCarsDetailsWidget");
var NeedsAndDemandsWidget_1 = require("./NeedsAndDemandsWidget");
var MultipleVehicleLengthAndRegistrationNumberCheckWidget_1 = require("./MultipleVehicleLengthAndRegistrationNumberCheckWidget");
var VehicleDetailsDisplayWidget_1 = require("./VehicleDetailsDisplayWidget");
var PriceTransparencyWrapper_1 = require("./priceTransparencyWidget/PriceTransparencyWrapper");
var DateOfBirthMismatchWarningPopupWidget_1 = require("./DateOfBirthMismatchWarningPopupWidget");
var CarUsageChoiceWidget_1 = require("./CarUsageChoiceWidget");
var HeadsUpPanelForEditingVehicleRegistrationNumber_1 = require("./HeadsUpPanelForEditingVehicleRegistrationNumber");
var ModificationsLookupWidget_1 = require("./ModificationsLookupWidget");
var RenewalReactivationPremiumWidget_1 = require("./RenewalReactivationPremiumWidget");
var AddDriverPriceOutputWidget_1 = require("./AddDriverPriceOutputWidget");
var AddDriverWidget_1 = require("./AddDriverWidget");
var AdditionalQuestionsWidget_1 = require("./AdditionalQuestionsWidget");
var CarCancellationPolarAnswerWidget_1 = require("./CarCancellationPolarAnswerWidget");
var CardWarningBanner_1 = require("./CardWarningBanner");
var ExtraProtectionOutputWidget_1 = require("./ExtraProtectionOutputWidget");
var QuoteSummaryPanelWidget_1 = require("./QuoteSummaryPanelWidget");
var ReplaceCarHeadsUpBannerWidget_1 = require("./ReplaceCarHeadsUpBannerWidget");
var ReplaceCarFooterBannerWidget_1 = require("./ReplaceCarFooterBannerWidget");
var ReplaceCarAlertBannerWidget_1 = require("./ReplaceCarAlertBannerWidget");
var SaveChangesWarningBanner_1 = require("./SaveChangesWarningBanner");
var VoluntaryExcessWidget_1 = require("./VoluntaryExcessWidget");
var EditVehicleRegistrationNumberInformation_1 = require("./EditVehicleRegistrationNumberInformation");
var MleAndGhcValidationBanner_1 = require("./MleAndGhcValidationBanner");
var addMotorWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "vehicleExistingDriverAdder",
        component: VehicleExistingDriverAdderWIdget_1.VehicleExistingDriverAdderWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "vehicleAddExistingDriverButton",
        component: VehcleAddExistingDriverButtonWidget_1.VehicleAddExistingDriverButtonWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "carExcessOutput",
        component: CarExcessWidget_1.CarExcessWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "addCarExcessOutput",
        component: AddCarExcessWidget_1.AddCarExcessWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "mainDriverPolarAnswer",
        component: MainDriverPolarAnswerWidget_1.MainDriverPolarAnswerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "carCancellationPriceOutput",
        component: CarCancellationPriceOutputWidget_1.CarCancellationPriceOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "viewAndEditCarDetailsOutput",
        component: ViewAndEditCarDetailsWidget_1.ViewAndEditCarDetailsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "carSpecificExcesses",
        component: CarSpecificExcessWidget_1.CarSpecificExcessWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "dateOfBirthMismatchWarningPopup",
        component: DateOfBirthMismatchWarningPopupWidget_1.DateOfBirthMismatchWarningPopupWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "carChangePriceOutput",
        component: CarChangePriceOutputWidget_1.CarChangePriceOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "whoIsRegisteredKeeperWidget",
        component: WhoIsRegisteredKeeperWidget_1.WhoIsRegisteredKeeperWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "registeredKeeperPopupWidget",
        component: DriverKeeperPopupWidget_1.default
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "displayMultipleCarsDetails",
        component: DisplayMultipleCarsDetailsWidget_1.DisplayMultipleCarsDetailsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "needsAndDemandsOutput",
        component: NeedsAndDemandsWidget_1.NeedsAndDemandsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "multipleVehicleLengthAndRegistrationNumberCheck",
        component: MultipleVehicleLengthAndRegistrationNumberCheckWidget_1.MultipleVehicleLengthAndRegistrationNumberCheckWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "vehicleDetailsOutput",
        component: VehicleDetailsDisplayWidget_1.VehicleDetailsDisplayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "priceTransparency",
        component: PriceTransparencyWrapper_1.PriceTransparencyWrapper
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "carUsageChoiceWidget",
        component: CarUsageChoiceWidget_1.CarUsageChoiceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "headsUpPanelForEditingVehicleRegistrationNumber",
        component: HeadsUpPanelForEditingVehicleRegistrationNumber_1.HeadsUpPanelForEditingVehicleRegistrationNumber
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "carModificationsLookup",
        component: ModificationsLookupWidget_1.ModificationsLookupWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalReactivationPremiumWidget",
        component: RenewalReactivationPremiumWidget_1.RenewalReactivationPremiumWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "addDriverPriceOutput",
        component: AddDriverPriceOutputWidget_1.AddDriverPriceOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "addDriver",
        component: AddDriverWidget_1.AddDriverWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "additionalQuestionsWidgetOutput",
        component: AdditionalQuestionsWidget_1.AdditionalQuestionsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "carCancellationPolarAnswer",
        component: CarCancellationPolarAnswerWidget_1.CarCancellationPolarAnswerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "cardWarningBanner",
        component: CardWarningBanner_1.CardWarningBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "extraProtectionOutput",
        component: ExtraProtectionOutputWidget_1.ExtraProtectionOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "quoteSummaryPanel",
        component: QuoteSummaryPanelWidget_1.QuoteSummaryPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "replaceCarHeadsUpBanner",
        component: ReplaceCarHeadsUpBannerWidget_1.ReplaceCarHeadsUpBannerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "replaceCarFooterBanner",
        component: ReplaceCarFooterBannerWidget_1.ReplaceCarFooterBannerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "replaceCarAlertBanner",
        component: ReplaceCarAlertBannerWidget_1.ReplaceCarAlertBannerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "saveChangesWarningBanner",
        component: SaveChangesWarningBanner_1.SaveChangesWarningBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "voluntaryExcessWidget",
        component: VoluntaryExcessWidget_1.VoluntaryExcessWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "editVehicleRegistrationNumberInformation",
        component: EditVehicleRegistrationNumberInformation_1.EditVehicleRegistrationNumberInformation
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "MleAndGhcValidationBanner",
        component: MleAndGhcValidationBanner_1.MleAndGhcValidationBanner
    });
};
exports.addMotorWidgets = addMotorWidgets;
//# sourceMappingURL=index.js.map